<template>
  <div class="scores">
    <div class="row">
      <div class="col-12">
        Merci d'avoir joué cette belle partie de Scrabble.<br />
        Le classement Lettre Compte Triple va être mis à jour dans 1 minute<br />
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        Total top : {{totalTop}} {{totalTop | pluralize('pt')}}
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <table class="table table-stripped table-sm">
          <thead>
            <tr>
              <th>#1</th>
              <th>Joueur</th>
              <th>Score</th>
              <th>% du top</th>
              <th>Score LCT</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(score, index) in finalScores"
              v-bind:key="score.userId"
              v-bind:class="scoreTdClass(score)">
              <td><img src="/static/cup.svg" width="30" v-if="index === 0"/>{{index + 1}}</td>
              <td>
                <img v-bind:src="score.picture" v-if="score.picture" class="thumb" />
                <img src="../../assets/default-profile.png" v-else class="thumb"/>
                {{score.username}}
              </td>
              <td>{{score.total}}pts</td>
              <td>{{(percentageFromTop(score.total)).toFixed(2)}}%</td>
              <td v-if="score.lctGameScore > 0">+{{score.lctGameScore}}pts</td>
              <td v-else></td>
            </tr>
            <tr v-if="scores.length === 0" class="text-center">
              <td colspan="4">Aucun score
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        Comment sont comptés les points ?<br />
        Les joueurs ayant marqué moins de 400 points ne sont pas comptés dans le classement.<br />
        Le gagnant de la partie marque 1,5 * le nombre de joueurs.<br />
        Exemple, s'il y a 10 joueurs:<br />
        - le gagnant marque 1,5 * 10 soit 15 points.<br />
        - Le second marque le score du gagnant moins 1,5.<br />
        - Le troisième marque le score du second moins 1,5.<br />
        - Et ainsi de suite.<br />
        Les scores sont ensuite arrondis à l'entier supérieur.
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'FinalScores',
  props: {
    scores: {
      type: Array,
      required: true,
    },
    totalTop: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      finalScores: [],
    };
  },
  created() {
    this.finalScores = this.calculLCTScoreForGame(this.scores);
  },
  methods: {
    scoreTdClass(score) {
      return {
        me: score.highlight,
      };
    },
    percentageFromTop(score) {
      return this.totalTop > 0
        ? (1 - ((this.totalTop - score) / this.totalTop)) * 100
        : 100;
    },
    calculLCTScoreForGame(scores) {
      return scores
        .map(score => ({
          ...score,
          lctGameScore: Math.ceil(scores
            .filter(p => p.total >= 400)
            .filter(p => Number(p.total) <= Number(score.total))
            .length * 1.5),
        }))
        .sort((a, b) => b.total - a.total);
    },
  },
};
</script>
<style scoped>
td{
  vertical-align: middle;
}
.me td{
  color: #6BBBAE;
  font-weight: bold;
}
.thumb{
  width: 60px;
}
</style>



// WEBPACK FOOTER //
// src/components/games/FinalScores.vue